module.exports = "<div class=\"cms-spinner sample-show-hide animated\" ng-show=\"$ctrl.active()\" >\n    <em class=\"fa fa-circle-o-notch fa-spin\"></em>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Loader/loader.html
// module id = 1024
// module chunks = 0